module.exports = __webpack_public_path__ + "static/media/days-01.0c0eac4a.png";